import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.405 11.595 1 14v4h3.785l-2 2-1.959 1.986h2.775l.598-.572L23.613 2h-2.828l-1.909 1.909A8 8 0 0 0 4 8v2.158a2.03 2.03 0 0 1-.595 1.437ZM17.4 5.384A6 6 0 0 0 6 8v2.158c0 1.07-.425 2.095-1.18 2.851L3 14.83V16h3.785L17.401 5.384Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 18H10.413l2-2H21v-1.172l-1.82-1.819a4.032 4.032 0 0 1-1.172-2.604L20 8.413v1.745c0 .54.214 1.056.595 1.437L23 14v4Zm-11 4a2 2 0 0 1-2-2H8a4 4 0 0 0 8 0h-2a2 2 0 0 1-2 2Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionUnsubscribe24 = createIcon(IconComponent);